var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenComponent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0023 5.66732C13.3705 5.66732 13.669 5.36884 13.669 5.00065V1.00065C13.669 0.632464 13.3705 0.333984 13.0023 0.333984H8.99991C8.63171 0.333984 8.33325 0.632458 8.33325 1.00065C8.33325 1.36884 8.63171 1.66732 8.99991 1.66732H11.393L5.6552 7.40505C5.39485 7.66538 5.39485 8.08752 5.6552 8.34785C5.91558 8.60825 6.33765 8.60825 6.59798 8.34785L12.3356 2.61023V5.00065C12.3356 5.36884 12.6341 5.66732 13.0023 5.66732ZM2.33331 2.33398C1.22875 2.33398 0.333313 3.22942 0.333313 4.33398V11.6673C0.333313 12.7719 1.22875 13.6673 2.33331 13.6673H9.66665C10.7712 13.6673 11.6666 12.7719 11.6666 11.6673V7.66732C11.6666 7.29912 11.3682 7.00065 11 7.00065C10.6318 7.00065 10.3333 7.29912 10.3333 7.66732V11.6673C10.3333 12.0355 10.0348 12.334 9.66665 12.334H2.33331C1.96513 12.334 1.66665 12.0355 1.66665 11.6673V4.33398C1.66665 3.9658 1.96513 3.66732 2.33331 3.66732H6.33331C6.70151 3.66732 6.99998 3.36884 6.99998 3.00065C6.99998 2.63246 6.70151 2.33398 6.33331 2.33398H2.33331Z",
    fill: "#666687"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenComponent);
export default __webpack_public_path__ + "static/media/open-component.34f6f76c8777ef7adc7e65ea9e1bf9d2.svg";
export { ForwardRef as ReactComponent };